import React from 'react'
import ChangePassword from 'src/app/ChangePassword/ChangePassword'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { changePasswordRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ChangePasswordAppRoute: AppRoute = {
  id: AppLocation.ChangePassword,
  routeProps: changePasswordRouteProps,
  component: <ChangePassword />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ChangePasswordAppRoute
